<template>
  <div>
    <v-row class="ma-0">
      <v-col md="6" :cols="12" class="pa-0">
        <div class="image-header">Pictures</div></v-col
      >
      <v-col md="6" :cols="12" class="pa-0">
        <div class="tab-header-text text-right">
          <v-btn
            @click="img_dialog = true"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-icon left>mdi-plus</v-icon>
            Add Picture
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <div v-if="images == null || images.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">mdi-image</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีรูปภาพให้แสดง</div>
      </v-row>
    </div>

    <v-row v-if="images !== null && images.length > 0" class="pt-5">
      <v-col
        v-for="image in images.slice(((pageNumber-1) * pageItemPerPage), (pageNumber * pageItemPerPage))"
        :key="image._id"
        class="d-flex child-flex col_grid_image"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        xs="12"
      >
        <v-card flat tile class="d-flex">
          <v-img
            :src="image.image"
            aspect-ratio="1"
            class="grey lighten-2 zoom"
            style="border-style: solid; border-width: 1px; border-radius: 3px;"
            @click="zoomImage(image.image)"
          >
            <div @click="confirmDeleteImage(image)" class="pa-0 ma-0" @click.stop.prevent>

                <v-btn
                  color="error"
                  dark
                  class="close-dialog pa-0 ma-3"
                >
                  <v-icon>mdi-window-close</v-icon>
                </v-btn>

            </div>
          </v-img>
        </v-card>
      </v-col>
    </v-row>

      <v-row justify="end" class="pt-5" v-if="images != null && images.length > 0">      
        <div>
          <v-pagination
            v-model="pageNumber"
            :length="Math.ceil(images.length/pageItemPerPage)"
          ></v-pagination>
        </div>
      </v-row>

      <v-dialog width="100%" max-width="800px" v-model="dialog_zoom" overlay-opacity="0.6" overlay-color="black">
          <v-img :src="selectedImage">
            <div class="close-btn">
              <v-btn icon class="close-dialog" elevation="1" @click="dialog_zoom = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-img>
      </v-dialog>

    <v-dialog v-model="dialogConfirmDeleteImage" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">ลบรูปภาพ</v-card-title>
        <v-card-text>คุณต้องการลบรูปภาพหรือไม่?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="dialogConfirmDeleteImage = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            elevation="0"
            class="px-7 ma-2 subtitle-2 font-weight-light"
            dark
            color="red"
            :disabled="deletingImage"
            @click="deleteImage(selectedDeleteImage._id);"
            >ลบรูปภาพ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <InsertImageDialog
      :isImageOpen.sync="img_dialog"
      :isImageClose="closeDialog"
      :idLive.sync="liveId"
    />
  </div>
</template>

<script>

import InsertImageDialog from '@/components/live/dialog/insertImageDialog.vue';
import { getListImage, deleteImage } from "@/service/course/livev2";

export default {
  props: {
    liveId: {
      type: String,
    },
  },
  components: {
    InsertImageDialog,
  },
  data() {
    return {
      dialog_zoom: false,
      selectedImage: "",
      img_dialog: false,
      images: [],

      dialogConfirmDeleteImage: false,
      selectedDeleteImage: "",
      deletingImage: false,

      pageNumber: 1,
      pageItemPerPage: 8,
    };
  },
  async mounted() {
    this.init();
  },
  methods: {
    async init(){
      this.getImageList();
    },
    confirmDeleteImage(image){
        this.selectedDeleteImage = image;
        this.dialogConfirmDeleteImage = true;
    },
    async deleteImage(imageId){
        this.deletingImage = true;
        await deleteImage(this.liveId, imageId);
        this.getImageList();
        this.dialogConfirmDeleteImage = false;
        this.deletingImage = false;
    },
    openNewWeb(url) {
      window.open(
        url,
        "vuetifyjs",
        "resizable,scrollbars,status,width=1000,height=700"
      );
    },
    zoomImage(src) {
      this.dialog_zoom = true;
      this.selectedImage = src;
    },
    closeDialog() {
      this.img_dialog = false;
      this.getImageList();
    },
    async getImageList() {
      let res = await getListImage(this.liveId);
      this.images = [];
      for(let i=0;i<res.length;i++){
        this.images.push(res[i]);
      }
    }
  }
};
</script>
<style scoped>
/* .live-image-card{
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.live-image-card:hover{
  transform: scale(1.15, 1.15);
  cursor: pointer;
} */
.zoom {
  cursor: zoom-in;
}
.no-data {
  color: #e1e2e6;
}
.col_grid_image {
  padding: 2px !important;
}
.toolbar_zoom {
  float: right;
  background-color: transparent !important;
  border-radius: 100%;
  border-top-left-radius: inherit !important;
  border-top-right-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
  border-bottom-right-radius: inherit !important;
}
.col_zoom {
  align-items: center;
  margin: 0px !important;
  padding: unset;
  border: unset;
}
/* .stylee_dialog_zoom {
  box-shadow: unset;
} */
.row_zoom {
  margin: unset;
}
.btn_zoom {
  color: white !important;
}
.description {
  font-size: 16px;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.close-dialog {
  float: right;
  margin-right: 10px;
}
@media only screen and (max-width: 960px) {
  .cardImg {
    height: 300px;
    width: 300px;
  }
}
@media only screen and (min-width: 961px) {
  .cardImg {
    height: 800px;
    width: 800px;
  }
}

.image-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
</style>